"use strict";
const React = require('react');
const react_router_1 = require('react-router');
const c = require('./theme/colors');
const routes = require('../utils/routes');
const RunningDuration_1 = require('./RunningDuration');
const StartTaskButton_1 = require('./StartTaskButton');
const TaskHistoryDots_1 = require('./TaskHistoryDots');
const handleStartTask = (task) => react_router_1.browserHistory.push(routes.runningTask(task.id));
const TaskListItem = (props) => {
    const { task } = props;
    return (React.createElement("div", null, 
        React.createElement("div", {style: style.root}, 
            React.createElement(react_router_1.Link, {style: style.leftColumn, to: routes.task(task.id)}, 
                React.createElement("div", {style: style.taskName}, task.name), 
                React.createElement(TaskHistoryDots_1.default, {active: !!task.activeSession, task: task}), 
                React.createElement(RunningDuration_1.RunningTaskDuration, {active: !!task.activeSession, task: task, style: style.duration})), 
            React.createElement("div", {style: style.rightColumn}, 
                React.createElement(StartTaskButton_1.default, {task: task, onStartTask: handleStartTask}), 
                React.createElement(RunningDuration_1.RunningGoalDuration, {active: !!task.activeSession, task: task, style: style.duration}))), 
        React.createElement("hr", {style: style.hr})));
};
const style = {
    root: {
        display: 'flex',
        margin: '16px 0',
        height: '120px',
        alignItems: 'center',
        lineHeight: '1.5em',
        fontSize: '14px',
    },
    leftColumn: {
        color: c.black,
        display: 'flex',
        flex: '1',
        flexDirection: 'column',
        textDecoration: 'none',
    },
    rightColumn: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'space-around',
        minWidth: '120px',
    },
    hr: {
        border: 'none',
        background: `-webkit-gradient(radial, 50% 50%, 0, 50% 50%, 350, from(${c.grey}), to(${c.white}))`,
        color: c.white,
        display: 'block',
        height: '1px',
        margin: 0,
        width: '100%',
    },
    taskName: {
        fontSize: '18px',
    },
    duration: {
        fontSize: '12px',
    },
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = TaskListItem;



/** WEBPACK FOOTER **
 ** ./src/components/TaskListItem.tsx
 **/